import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress, Alert } from '@mui/material';
import SafeRedirect from './SafeRedirect';
import { useFeatureFlags } from '../contexts/FeatureFlagsContext';

/**
 * FeatureProtectedRoute component - Checks authentication and feature flags
 * Uses the FeatureFlagsContext for live Hub + local Firestore updates.
 */
const FeatureProtectedRoute = ({ featureName, redirectTo = '/dashboard', children }) => {
  const { currentUser, loading: authLoading } = useAuth();
  const { isEnabled, loading: flagsLoading } = useFeatureFlags();

  if (authLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!currentUser) {
    return <SafeRedirect to="/login" replace />;
  }

  if (featureName && flagsLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (featureName && !isEnabled(featureName)) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="warning" sx={{ mb: 2 }}>
          This feature has been disabled. Please contact your administrator to enable it.
        </Alert>
        <SafeRedirect to={redirectTo} replace />
      </Box>
    );
  }

  return children;
};

export default FeatureProtectedRoute;
